import Vue from 'vue';
import store from '@/store';
import VueRouter from 'vue-router';
import { MENUS } from '@/config/menus';
import ShareRouter from './modules/share.router';
import MemberRouter from './modules/member.router';
import AuthRouter from './modules/auth.router';
import SettingRouter from './modules/setting.router';
import MailInvite from './modules/mailInvite.router';
import { checkRouterWithToken } from './main';
import { generateStorageKey } from '@/utils';
import { APP_TOKEN_NAME } from '@/config/constants';

Vue.use(VueRouter);

const routes = [
    ...AuthRouter,
    ...SettingRouter,
    ...ShareRouter,
    ...MemberRouter,
    ...MailInvite,
    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/Profile')
    },
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home')
    },
    {
        path: '*',
        component: () => import('@/views/NotFound')
    },
    {
        path: '/notFound',
        component: () => import('@/views/NotFound')
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    let token = window.$cookies.get(generateStorageKey(APP_TOKEN_NAME));
    let userInfo = JSON.parse(localStorage.getItem('KB_DEV_CUSTOMER'));
    return next(checkRouterWithToken(token, to, userInfo));
});

router.afterEach((to, from, next) => {
    let currentPath = to.name;
    let currentMenu;
    for (let index in MENUS) {
        let menu = MENUS[index];

        if (Array.isArray(menu.pathList) && menu.pathList.indexOf(currentPath) !== -1) {
            currentMenu = menu;
            break;
        }
    }
    if (currentMenu === undefined) {
        currentMenu = null;
    }
    store.commit('updateCurrentMenu', currentMenu);
    store.commit('updateCurrentPath', currentPath);
});
export default router;
